// extracted by mini-css-extract-plugin
export default {"wave":"wave__wave__Fd6QF","waveFullWidth":"wave__waveFullWidth__iQvKj"};